import { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"

const History = props => {
  const [historyItems, sethistoryItems] = useState()
  const [mounted, setmounted] = useState(false)

  useEffect(() => {
    // console.log("items --> ", props.data)
    const items = props.data.map((item, idx) => (
      <HistoryItem
        reason={item.reason}
        status={item.application_status.name}
        staff_firstname={item.staff ? item.staff.first_name : null }
        staff_last_name = {item.staff ? item.staff.last_name : null }
        decision={item.decision ? item.decision : null}
        comment_to_applicant = {item.comment_to_applicant}
        key={idx}
        index={idx}
        updated_at={item.updated_at}
      />
    ))
    sethistoryItems(items)
    setmounted(true)
  }, [])
  return (
    <Row>
      <Col lg={12}>
        <Card>
          <CardBody>
            {mounted ? (
              <div id="cd-timeline">
                <ul className="timeline list-unstyled">{historyItems}</ul>
              </div>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

const HistoryItem = props => {
  const [liClass, setliClass] = useState()
  const [day, setday] = useState()
  const [month, setmonth] = useState()

  useEffect(() => {
    if (props.index % 2 == 0) {
      setliClass("timeline-list")
    } else {
      setliClass("timeline-list right clearfix")
    }
    const dt = new Date(props.updated_at)
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ]
    setday(dt.getDate())
    setmonth(months[dt.getMonth()])
  }, [])

  return (
    <li className={liClass}>
      <div className="cd-timeline-content p-2">
<div className="cd-timeline-content p-2">
  <div>
    <strong> Date: </strong>
    <span className="mt-0 mb-3">{props.updated_at}</span>
  </div>

  <div>
    <strong>Status: </strong>
    <span className="mt-0 mb-3 badge bg-info rounded">{props.status}</span>
  </div>


  {props.decision && (
    <div>
      <strong>Decision: </strong>
      <span className="mt-0 mb-3 font-weight-bold">{props.decision}</span>
    </div>
  )}
    
  {props.reason && (
    <div>
      <strong>Reason: </strong>
      <p className="mt-0 mb-3 font-weight-bold">{props.reason}</p>
    </div>
  )}

  {props.comment_to_applicant && (
    <div>
      <strong>Comment to Applicant: </strong>
      <p className="mt-0 mb-3 font-weight-bold">{props.comment_to_applicant}</p>
    </div>
  )}

  {props.staff_firstname && (
    <div>
      <strong>Staff Name :</strong>
      <span className="mt-0 mb-3 font-weight-bold">{props.staff_firstname} {props.staff_last_name} </span>
    </div>
  )}

  <div className="date bg-primary">
    <h4 className="mt-0">{day}</h4>
    <p className="mb-0 text-white-50">{month}</p>
  </div>
</div>



  <div className="date bg-primary">
    <h4 className="mt-0">{day}</h4>
    <p className="mb-0 text-white-50">{month}</p>
  </div>
</div>

     
    </li>
  )
}

export default History
